/**
 * 装载率明细 货量表
 * @startDate
 * @endDate
 * @scanSite
 * @type
 */
export const loadingRateGoodsQuery = params => {
  return {
    // title: '中转发出-实际',
    dataSource: 't_load_rate_goods_result',
    dimensions: [
      // 'taskNo',
      // 'calcWeight',
      // 'departureProvinceArea',
      // 'departureCenter',
      // 'departureCenterCode',
      // 'arrivalProvinceArea',
      // 'arrivalCenter',
      // 'arrivalCenterCode',
      'direction',
    ],
    simpleGranularity: params.type || 'day',
    startDate: params.startDate,
    endDate: params.endDate,
    andFilters: [
      // { key: 'transportLineType', value: params.transportLineType },
      // {key: 'isDestinationCenter', value: '否'},
      // {key: 'scanSite', value: params.scanSite},
    ],
  };
};


/**
 * 装载率明细 运力表
 * @startDate
 * @endDate
 * @scanSite
 * @type
 */
 export const loadingRateVolumeQuery = params => {
  return {
    // title: '中转发出-实际',
    dataSource: 't_load_rate_volume_result',
    dimensions: [
      // 'taskNo',
      // 'calcWeight',
      // 'departureProvinceArea',
      // 'departureCenter',
      // 'departureCenterCode',
      // 'arrivalProvinceArea',
      // 'arrivalCenter',
      // 'arrivalCenterCode',
      'direction',
    ],
    simpleGranularity: params.type || 'day',
    startDate: params.startDate,
    endDate: params.endDate,
    andFilters: [
      // { key: 'transportLineType', value: params.transportLineType },
      // {key: 'isDestinationCenter', value: '否'},
      // {key: 'scanSite', value: params.scanSite},
    ],
  };
};